define('modules/signup/resetpassword/view',['require','exports','module','backbone','views/BaseView','env','ThemesHelper','../../../helpers/PasswordValidatorHelper','../../../helpers/UIHelper','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
    BaseView = require("views/BaseView"),
    Config = require("env"),
    ThemesHelper = require("ThemesHelper"),
    PasswordValidatorHelper = require("../../../helpers/PasswordValidatorHelper"),
    UIHelper = require("../../../helpers/UIHelper");

  var ResetPasswordView = BaseView.extend({
    template: require("ldsh!./template"),

    initialize: function (options) {
      if (this.model) {
        this.listenTo(this.model, "reset sync request error", this.render);
      }
    },

    initPasswordReveal: function () {
      const revealButton = $('.password__toggle');

      revealButton.on('mousedown', function (e) {
        const passwordField = $(this).siblings('.password');
        passwordField.attr('type', 'text');
      }).on('mouseup', function (e) {
        const passwordField = $(this).siblings('.password');
        passwordField.attr('type', 'password');
      }).on('mouseleave', function (e) {
        const passwordField = $(this).siblings('.password');
        passwordField.attr('type', 'password');
      }).on('click', function (e) {
        e.preventDefault();
      });
    },

    afterRender: function () {
      BaseView.prototype.afterRender.call(this);
      var self = this;

      this.initPasswordReveal();

      UIHelper.expandBackground().listeningResize();

      $("#resetPasswordForm").bootstrapValidator({
        onSuccess: function (e) {
          e.preventDefault();
          self.submitForm();
        },
        fields: {
          password: {
            validators: {
              callback: {
                callback: function (value, validator, $field) {
                  return PasswordValidatorHelper.passwordValidator(
                    $field.val()
                  );
                },
              },
              identical: {
                field: "userPasswordAgain",
                message: $.i18n.translate(
                  "FORM.VALIDATION.TXT_PASSWORD_IDENTICAL"
                ),
              },
            },
          },
          userPasswordAgain: {
            validators: {
              identical: {
                field: "password",
                message: $.i18n.translate(
                  "FORM.VALIDATION.TXT_PASSWORD_IDENTICAL"
                ),
              },
            },
          },
        },
      });
    },

    serialize: function () {
      return {
        model: this.model,
        accountsUrl: Config.defaultDomain + "accounts/user/me",
        globalAssetsURL: ThemesHelper.getCurrentThemeGlobalURL(),
        isForced: _useForcePassword(),
        logoutUrl:
          Config.authUrl +
          "/module.php/core/authenticate.php/core/authenticate.php?as=mdirector&logout",
      };
    },

    submitForm: function () {
      this.model.set({ password: $("#password").val() });
      this.model.set({ saved: true });
      this.model.save();
    },
  });

  function _useForcePassword() {
    return location.pathname.match(/\/force$/);
  }

  module.exports = ResetPasswordView;
});

